var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolVertecisMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_219_4775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7793 29.5234C5.7793 16.2686 16.5245 5.52344 29.7793 5.52344H77.7793C91.0341 5.52344 101.779 16.2686 101.779 29.5234V77.5234C101.779 90.7783 91.0341 101.523 77.7793 101.523H29.7793C16.5245 101.523 5.7793 90.7783 5.7793 77.5234V29.5234Z",
    fill: "url(#paint0_linear_219_4775)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0076 62.1757C28.0076 64.8494 30.2032 67.0453 32.8771 67.0453C34.7684 67.0453 36.4423 65.9148 37.2249 64.306L70.0076 73.8929C70.5294 75.9799 72.4422 77.5234 74.7033 77.5234C77.3554 77.5234 79.551 75.3494 79.551 72.6757C79.551 70.654 78.2902 68.9147 76.5509 68.1972L75.6162 46.2843C77.4859 45.6321 78.8336 43.8495 78.8336 41.7408C78.8336 39.0669 76.6598 36.893 74.0076 36.893C72.225 36.893 70.6814 37.8495 69.8119 39.2408L51.7031 34.2843C51.6379 31.6539 49.4858 29.5234 46.8771 29.5234C44.2032 29.5234 42.0076 31.7191 42.0076 34.393C42.0076 35.8278 42.638 37.1104 43.638 38.0234L33.551 57.4148C33.3119 57.3495 33.0945 57.3277 32.8771 57.3277C30.2032 57.3277 28.0076 59.5017 28.0076 62.1757ZM36.3989 58.8713L46.5076 39.1756C48.2032 39.393 49.8336 38.5886 50.7032 37.2408L69.2467 42.3278C69.399 44.2191 70.7685 45.8495 72.5727 46.393L73.3336 68.0018C71.8989 68.4147 70.725 69.4799 70.2032 70.8496L37.5728 61.2625C37.4423 60.3278 37.051 59.5669 36.3989 58.8713Z",
    fill: "url(#paint1_linear_219_4775)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_219_4775",
    x: 0.779297,
    y: 0.523438,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_219_4775"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4775",
    x1: 53.7793,
    y1: 5.52344,
    x2: 53.7793,
    y2: 101.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4775",
    x1: 53.7792,
    y1: 29.5234,
    x2: 53.7792,
    y2: 77.5234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolVertecisMedium);
export default __webpack_public_path__ + "static/media/symbol-vertecis-medium.b95a9898e647e3059d3b5766454adc1a.svg";
export { ForwardRef as ReactComponent };